var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _g2, _path28, _path29, _path30, _g3, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroimagev4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 902,
    height: 616,
    viewBox: "0 0 902 616",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_408_60",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 902,
    height: 618
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M242.241 117.154C-10.8927 173.569 -70.884 423.201 87.0903 617.461H887.09C896.782 591.351 911.013 527.193 893.568 495.861C871.762 456.696 841.96 430.377 850.44 351.733C898.414 99.5084 748.193 12.7183 602.333 1.75206C456.473 -9.21422 365.307 31.5428 242.241 117.154Z",
    fill: "url(#paint0_linear_408_60)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_408_60)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.241 117.154C-10.8926 173.569 -70.8839 423.201 87.0904 617.461H887.09C896.782 591.351 911.013 527.193 893.568 495.861C871.762 456.696 841.96 430.377 850.44 351.733C898.414 99.5084 748.193 12.7183 602.333 1.75206C456.473 -9.21422 365.307 31.5428 242.241 117.154Z",
    fill: "url(#paint1_linear_408_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020.93 457.384H1067.44H1099.76L1111.59 637.055L1008.31 642.714L351.59 617.249V484.264V470.588H378.001V440.878L419.391 437.577L416.238 497.468H457.628V519.632H474.972V506.899H494.287L499.018 457.384H543.561V375.329H583.375V420.601H594.018V382.403H631.072V445.594H643.686V432.39L726.86 429.561V463.043H750.117V375.329H830.532V489.451H859.308V470.588H892.42V437.577H934.993L938.146 497.468H976.777V519.632H997.275V506.899H1017.38L1020.93 457.384Z",
    fill: "url(#paint2_linear_408_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.59 689.259L331.09 36.1465L-20.9097 54.4673L-37.9097 661.53L347.59 689.259Z",
    fill: "url(#paint3_linear_408_60)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.715,
    y: 127.751,
    width: 321.75,
    height: 176.214,
    rx: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.235 175.793C556.693 144.718 525.192 189.579 516.59 213.908H628.59V150.654C613.726 148.383 613.623 177.415 605.881 189.174C595.558 201.338 582.655 209.042 569.235 175.793Z",
    fill: "url(#paint4_linear_408_60)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.59,
    y: 301.551,
    width: 338,
    height: 8.85093,
    rx: 4,
    fill: "#C1D1FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456.778,
    y: 155.108,
    width: 19.5,
    height: 9.65556,
    rx: 3,
    fill: "#122738"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456.778,
    y: 169.591,
    width: 26.8125,
    height: 3.21852,
    rx: 1,
    fill: "#3F5566"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456.778,
    y: 178.442,
    width: 53.625,
    height: 3.21852,
    rx: 1,
    fill: "#3F5566"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456.778,
    y: 187.293,
    width: 53.625,
    height: 3.21852,
    rx: 1,
    fill: "#3F5566"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456.778,
    y: 196.144,
    width: 53.625,
    height: 3.21852,
    rx: 1,
    fill: "#3F5566"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456.778,
    y: 204.995,
    width: 39,
    height: 3.21852,
    rx: 1,
    fill: "#3F5566"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.34 281.435V269.014C545.34 266.098 547.705 263.733 550.622 263.733V263.733C553.538 263.733 555.903 266.098 555.903 269.014V281.435H545.34Z",
    fill: "url(#paint5_linear_408_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.903 281.435V251.312C581.903 248.396 584.267 246.031 587.184 246.031V246.031C590.101 246.031 592.465 248.396 592.465 251.312V281.435H581.903Z",
    fill: "url(#paint6_linear_408_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.59 281.435V272.631C600.59 269.939 602.773 267.756 605.465 267.756V267.756C608.158 267.756 610.34 269.939 610.34 272.631V281.435H600.59Z",
    fill: "url(#paint7_linear_408_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.465 281.435V263.78C618.465 261.088 620.648 258.905 623.34 258.905V258.905C626.033 258.905 628.215 261.088 628.215 263.78V281.435H618.465Z",
    fill: "#122738"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.028 281.435V261.366C564.028 258.674 566.21 256.491 568.903 256.491V256.491C571.595 256.491 573.778 258.674 573.778 261.366V281.435H564.028Z",
    fill: "url(#paint8_linear_408_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.859 464.316H656.618H689.112L701 643.987L597.178 649.646L-63 624.181V491.196V477.52H-36.4502V447.811L5.15768 444.51L1.98756 504.4H43.5954V526.564H61.0311V513.832H80.4481L85.2033 464.316H129.981V382.261H170.004V427.533H180.703V389.335H217.952V452.526H230.633V439.322L314.245 436.493V469.975H337.625V382.261H418.463V496.383H447.39V477.52H480.676V444.51H523.473L526.643 504.4H565.477V526.564H586.083V513.832H606.293L609.859 464.316Z",
    fill: "url(#paint9_linear_408_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.59 -20.7675C363.59 -22.4244 364.933 -23.7675 366.59 -23.7675V-23.7675C368.247 -23.7675 369.59 -22.4244 369.59 -20.7675V127.751H363.59V-20.7675Z",
    fill: "#C1D1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.59 -20.7675C597.59 -22.4244 598.933 -23.7675 600.59 -23.7675V-23.7675C602.247 -23.7675 603.59 -22.4244 603.59 -20.7675V127.751H597.59V-20.7675Z",
    fill: "#C1D1FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M503.09 292.143C487.35 292.143 474.59 279.506 474.59 263.919C474.59 248.331 487.35 235.695 503.09 235.695C518.83 235.695 531.59 248.331 531.59 263.919C531.59 279.506 518.83 292.143 503.09 292.143ZM503.09 277.288C510.546 277.288 516.59 271.302 516.59 263.919C516.59 256.535 510.546 250.549 503.09 250.549C495.634 250.549 489.59 256.535 489.59 263.919C489.59 271.302 495.634 277.288 503.09 277.288Z",
    fill: "#E1E8FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M509.09 287.191C493.35 287.191 480.59 274.555 480.59 258.967C480.59 243.379 493.35 230.743 509.09 230.743C524.83 230.743 537.59 243.379 537.59 258.967C537.59 274.555 524.83 287.191 509.09 287.191ZM509.09 272.336C516.546 272.336 522.59 266.351 522.59 258.967C522.59 251.584 516.546 245.598 509.09 245.598C501.634 245.598 495.59 251.584 495.59 258.967C495.59 266.351 501.634 272.336 509.09 272.336Z",
    fill: "url(#paint10_linear_408_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.09 238.171C497.492 238.171 488.09 247.481 488.09 258.967C488.09 270.453 497.492 279.764 509.09 279.764V279.764C520.688 279.764 530.09 270.453 530.09 258.967",
    stroke: "white",
    strokeWidth: 15
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M627.03 605.169C643.02 606.106 656.116 601.001 660.665 598.332C666.773 597.876 679.313 597.292 680.611 598.603C682.234 600.243 681.901 610.804 680.411 616.009C678.921 621.214 665.053 618.505 663.591 618.391C662.422 618.3 661.862 616.426 661.729 615.501C660.215 615.569 653.965 616.104 641.077 617.695C619.873 619.734 622.488 605.374 627.03 605.169Z",
    fill: "#E6EDFB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M677.635 600.51L661.322 599.74C660.131 599.684 659.256 598.607 659.446 597.43L691.91 395.98L731.929 402.566L723.083 439.043L701.265 516.921L680.693 598.242C680.343 599.628 679.063 600.577 677.635 600.51Z",
    fill: "url(#paint11_linear_408_60)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M770.59 596.664C770.285 600.76 758.032 598.405 751.59 598.15C722.206 493.295 721.302 423.883 725.481 400.875L765.448 403.435L760.189 500.959C763.381 531.137 770.896 592.569 770.59 596.664Z",
    fill: "url(#paint12_linear_408_60)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M718.099 605.058C734.11 605.51 747.043 600.012 751.508 597.206C757.599 596.566 770.115 595.602 771.453 596.874C773.125 598.463 773.118 609.03 771.79 614.277C770.462 619.525 756.516 617.237 755.052 617.167C753.88 617.111 753.263 615.256 753.101 614.335C751.59 614.449 745.359 615.172 732.527 617.153C711.395 619.833 713.566 605.401 718.099 605.058Z",
    fill: "#E6EDFB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M778.678 302.628C775.849 297.67 762.404 290.388 756.035 287.367L727.257 301.179L724.981 285.38L700.592 289.31C698.108 289.71 696.304 291.891 696.377 294.403L697.042 317.103C695.149 341.84 691.348 392.749 691.292 398.485C699.764 404.629 744.062 405.851 765.152 405.693L770.753 347.551C774.573 334.642 781.506 307.586 778.678 302.628Z",
    fill: "url(#paint13_linear_408_60)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M762.968 329.541C758.917 381.623 741.444 401.494 733.343 405.045L772.888 406.402L779.791 331.706C779.08 331.231 774.72 330.134 762.968 329.541Z",
    fill: "url(#paint14_linear_408_60)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M741.205 437.643L748.886 427.72L760.628 433.251C759.736 433.423 757.404 436.167 755.217 445.763C752.483 457.758 751.491 456.482 744.995 457.369C736.9 457.475 739.997 451.557 742.189 447.819C743.163 445.552 744.755 441.086 743.327 441.361C736.871 442.828 739.222 439.493 741.205 437.643Z",
    fill: "url(#paint15_linear_408_60)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M789.31 374.059C792.232 365.935 783.684 324.138 779.1 303.831C753.133 311.688 763.711 372.487 762.933 378.417C762.155 384.347 746.48 424.252 746.183 426.511C745.887 428.769 756.885 433.343 762.835 434.396C768.786 435.449 785.658 384.213 789.31 374.059Z",
    fill: "url(#paint16_linear_408_60)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M750.132 283.736C747.712 282.735 748.888 273.335 749.778 268.759L727.193 270.734L725.266 285.417L726.612 301.67L726.786 302.554L738.174 293.108L755.538 286.729C754.104 285.874 751.015 284.079 750.132 283.736Z",
    fill: "#FFB27F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M737.567 303.942C732.973 298.297 729.76 299.778 728.72 301.08C724.702 298.553 746.534 286.431 748.145 285.203C749.433 284.22 749.309 282.96 749.085 282.453C751.342 282.935 756.008 284.492 756.624 286.869C757.394 289.839 740.518 305.757 737.567 303.942Z",
    fill: "url(#paint17_linear_408_60)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M728.241 265.416L724.329 290.199C737.111 285.101 743.346 273.784 744.866 268.762L728.241 265.416Z",
    fill: "#F3A36A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M740.4 274.731C708.182 299.298 710.35 262.153 715.53 241.093L736.416 236.603L752.401 249.571L753.114 264.02L747.663 270.21L740.4 274.731Z",
    fill: "#FFB27F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M748.799 272.079L746.925 268.679C747.582 268.094 749.119 266.55 750.01 265.056C752.239 258.681 748.648 259.234 746.574 260.307C744.951 261.63 741.499 264.076 740.675 263.281C739.646 262.287 743.201 257.289 740.387 256.639C737.573 255.99 737.299 253.658 737.384 250.797C737.47 247.937 738.373 245.469 735.485 245.384C707.06 245.459 715.733 236.812 715.956 235.118C717.23 229.826 742.179 218.68 756.182 235.701C767.385 249.318 755.928 265.626 748.799 272.079Z",
    fill: "#122738"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M723.239 298.652L720.451 300.016C715.989 302.198 718.392 291.711 719.894 286.161L725.248 285.128C726.536 289.313 727.593 298.178 727.157 299.73C726.722 301.282 724.389 299.47 723.239 298.652Z",
    fill: "url(#paint18_linear_408_60)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M634.276 364.443C636.954 365.247 642.738 364.766 645.296 364.425C648.087 367.465 652.84 373.666 649.528 374.158C645.388 374.774 637.15 384.625 627.145 385.635C607.856 384.588 621.34 376.848 623.843 375.447C626.347 374.046 633.286 369.771 631.365 368.949C621.756 364.841 630.928 363.438 634.276 364.443Z",
    fill: "url(#paint19_linear_408_60)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M681.529 337.725L695.338 294.624C696.139 292.123 699.83 292.691 699.829 295.315L699.826 310.913L695.525 348.19L692.015 354.669C679.83 361.187 654.564 374.742 650.981 376.822C647.696 376.63 644.336 367.4 643.067 362.808L681.529 337.725Z",
    fill: "url(#paint20_linear_408_60)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M698.169 318.723L691.024 354.533L694.715 348.147L698.169 318.723Z",
    fill: "url(#paint21_linear_408_60)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M290.59 433.262C288.59 437.224 282.823 430.545 279.59 430.787C278.474 415.873 282.085 408.893 286.269 405.22C291.498 400.627 297.684 411.305 294.852 416.422C292.02 421.539 295.505 423.529 290.59 433.262Z",
    fill: "#F7B39D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M297.189 417.074C297.504 420.544 289.227 421.304 285.049 421.25L254.391 352.588L246.035 308.516L262.224 306.575C269.76 315.493 285.688 333.76 287.136 336.068C289.09 339.183 296.796 412.737 297.189 417.074Z",
    fill: "#F2FDFF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M275.112 562.893C276.296 570.508 275.534 589.875 275.112 597.655C274.059 598.784 253.433 602.235 251.59 600.13C249.748 598.026 252.752 575.305 253 570.508C253.198 566.669 251.089 548.382 250.01 539.719C253.216 526.462 255.612 495.143 256.746 488.308C257.879 481.473 263.49 439 264.005 417.07L288.143 416.123C283.205 452.011 285.366 501.637 285.552 510.684C285.785 521.992 273.633 553.375 275.112 562.893Z",
    fill: "url(#paint22_linear_408_60)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M258.033 493.045C258.011 503.493 255.269 533.854 251.504 555.113C248.498 572.09 249.288 589.452 250.062 596.051C250.064 596.063 250.077 596.348 250.119 597.391C250.39 600.863 229.403 601.468 225.006 601.423C220.608 601.378 222.986 589.378 222.496 577.145C221.862 561.282 221.903 523.845 224.007 510.486C225.323 502.128 224.605 459.533 217.238 445.675C211.344 434.589 213.953 420.339 215.995 414.6L276.977 417.214L266.34 437.002C263.578 452.2 258.05 484.687 258.033 493.045Z",
    fill: "#3D8F7D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M262.668 312.216C277.779 347.144 256.76 322.025 244.362 305.099L244.579 310.532C266.074 342.423 266.504 395.28 264.031 417.722L266.445 417.627C288.127 419.04 293.251 415.632 293.103 413.752C291.18 393.151 286.814 349.923 285.575 340.918C284.336 331.912 269.869 314.546 262.909 307.201C262.78 307.641 262.908 309.421 262.668 312.216Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M292.327 609.821C287.188 608.803 278.726 601.286 275.138 597.654C266.542 597.048 249.491 597.136 250.051 602.338C250.611 607.539 250.157 615.973 249.86 619.539C262.306 619.341 288.727 618.711 294.843 617.775C302.488 616.604 298.752 611.092 292.327 609.821Z",
    fill: "#E6EDFB"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M266.221 609.572C261.082 608.554 252.62 601.036 249.032 597.405C240.436 596.799 223.385 596.887 223.945 602.089C224.105 603.574 224.182 605.323 224.204 607.148C224.281 613.655 229.397 619.201 235.903 619.045C248.736 618.738 264.236 618.215 268.737 617.526C276.383 616.355 272.646 610.843 266.221 609.572Z",
    fill: "#E6EDFB"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M262.402 344.003L243.88 304.03L234.57 296.56C231.258 297.996 223.381 302.527 218.372 309.166C213.363 315.805 214.69 363.649 215.98 386.742L215.454 406.568C215.082 408.252 214.359 412.14 214.442 414.226C234.225 425.29 256.698 423.015 265.461 420.495L267.699 377.531L262.402 344.003Z",
    fill: "#F2FDFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_408_60",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 237,
    y: 253,
    width: 42,
    height: 77
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M274.183 299.359C281.556 299.07 277.54 273.4 274.611 260.601L260.474 253.32L237.086 267.514L237.241 298.849C241.057 302.69 249.758 312.505 255.478 319.246C272.504 340.516 269.132 325.457 262.669 312.216L263.511 301.542C263.591 300.532 264.411 299.742 265.423 299.702L274.183 299.359Z",
    fill: "#F7B39D"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_408_60)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.09 298.849C279.463 298.56 276.52 273.747 273.59 260.948L260.474 253.32L237.086 267.514L237.24 298.849C241.057 302.69 249.758 312.505 255.478 319.246C272.504 340.516 269.132 325.457 262.669 312.216L263.511 301.542C263.59 300.532 264.381 299.558 265.381 299.394C266.533 299.206 268.521 298.989 272.09 298.849Z",
    fill: "#F7B39D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.59 298.58C257.39 299.372 263.923 299.57 267.09 299.57L263.09 312.939C260.59 307.823 255.79 297.787 256.59 298.58Z",
    fill: "#E89B81"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M273.772 260.676C271.865 261.224 269.755 261.671 267.677 262.03C262.309 262.957 257.717 267.682 255.036 272.422C253.486 275.162 251.801 277.477 251.315 278.894C250.938 279.991 251.583 284.439 252.571 289.68C254.246 298.565 248.192 307.177 239.183 307.927C234.744 308.296 230.011 308.65 225.756 308.884C217.58 309.334 210.267 304.809 209.679 296.641C209.203 290.03 209.98 283.015 211.107 279.165C212.034 275.998 212.668 273.092 213.251 269.815C214.751 261.384 216.871 252.487 223.595 247.188C236.573 236.961 254.577 240.193 266.99 245.338C271.984 247.407 275.839 251.901 276.28 257.287C276.412 258.902 275.329 260.229 273.772 260.676Z",
    fill: "#122738"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M209.396 394.102C200.336 332.428 213.495 311.598 219.355 313.399L230.718 322.748C232.325 326.312 235.742 334.086 236.549 336.666C237.355 339.246 234.324 361.638 232.708 372.511C241.332 373.841 259.631 376.373 263.83 375.86C269.74 369.752 272.196 369.084 273.723 368.806C275.251 368.529 276.562 364.479 282.267 364.255C284.088 364.184 283.46 366.602 280.044 369.13C276.629 371.658 277.709 371.181 279.508 372.198C290.539 371.069 287.186 375.525 284.131 377.894C283.835 379.646 282.916 383.774 281.609 386.263C279.975 389.374 260.234 388.634 257.33 389.174C250.85 390.38 217.163 395.973 209.396 394.102Z",
    fill: "#FFB37D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M209.462 394.099C200.402 332.425 213.561 311.595 219.421 313.397L230.783 322.745C232.391 326.309 235.808 334.083 236.615 336.663C237.421 339.244 234.39 361.635 232.774 372.508C238.336 373.366 247.921 374.724 255.154 375.443L257.396 389.172C250.916 390.377 217.229 395.971 209.462 394.099Z",
    fill: "#3D8F7D"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_408_60)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 335.59,
    y: 155.479,
    width: 105,
    height: 68.3317,
    rx: 8,
    fill: "url(#paint23_linear_408_60)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.322289,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M369.413 214.187C383.631 214.187 395.158 203.199 395.158 189.645C395.158 176.091 383.631 165.103 369.413 165.103C355.194 165.103 343.667 176.091 343.667 189.645C343.667 203.199 355.194 214.187 369.413 214.187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M369.413 214.187C383.631 214.187 395.158 203.199 395.158 189.645C395.158 189.645 377.877 189.645 369.237 189.645L369.413 214.187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.749 188.923H411.816",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.749 195.901H417.874",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.749 203.119H408.283",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.749 210.097H422.922",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.811 176.708C407.021 176.708 407.184 176.767 407.301 176.883C407.422 177 407.483 177.154 407.483 177.345V178.479H400.441V177.849C400.441 177.728 400.466 177.597 400.518 177.457C400.569 177.313 400.655 177.182 400.777 177.065L403.787 174.048C404.043 173.792 404.27 173.547 404.466 173.313C404.662 173.075 404.825 172.844 404.956 172.62C405.086 172.392 405.184 172.161 405.25 171.927C405.315 171.694 405.348 171.449 405.348 171.192C405.348 170.74 405.231 170.397 404.998 170.163C404.764 169.925 404.435 169.806 404.011 169.806C403.824 169.806 403.651 169.834 403.493 169.89C403.339 169.942 403.199 170.014 403.073 170.107C402.951 170.201 402.846 170.31 402.758 170.436C402.669 170.562 402.604 170.7 402.562 170.849C402.478 171.083 402.363 171.239 402.219 171.318C402.079 171.393 401.878 171.409 401.617 171.367L400.595 171.185C400.669 170.691 400.809 170.257 401.015 169.883C401.22 169.51 401.477 169.2 401.785 168.952C402.093 168.705 402.445 168.521 402.842 168.399C403.238 168.273 403.665 168.21 404.123 168.21C404.603 168.21 405.04 168.283 405.432 168.427C405.828 168.567 406.167 168.766 406.447 169.022C406.727 169.274 406.944 169.58 407.098 169.939C407.252 170.299 407.329 170.695 407.329 171.129C407.329 171.503 407.275 171.848 407.168 172.165C407.06 172.483 406.913 172.786 406.727 173.075C406.545 173.36 406.332 173.638 406.09 173.908C405.847 174.179 405.59 174.452 405.32 174.727L403.164 176.932C403.402 176.862 403.637 176.809 403.871 176.771C404.104 176.729 404.323 176.708 404.529 176.708H406.811ZM415.884 173.397C415.884 174.284 415.788 175.054 415.597 175.707C415.405 176.361 415.142 176.902 414.806 177.331C414.47 177.756 414.071 178.073 413.609 178.283C413.151 178.489 412.657 178.591 412.125 178.591C411.593 178.591 411.098 178.489 410.641 178.283C410.183 178.073 409.789 177.756 409.458 177.331C409.126 176.902 408.865 176.361 408.674 175.707C408.487 175.054 408.394 174.284 408.394 173.397C408.394 172.511 408.487 171.743 408.674 171.094C408.865 170.441 409.126 169.902 409.458 169.477C409.789 169.048 410.183 168.731 410.641 168.525C411.098 168.315 411.593 168.21 412.125 168.21C412.657 168.21 413.151 168.315 413.609 168.525C414.071 168.731 414.47 169.048 414.806 169.477C415.142 169.902 415.405 170.441 415.597 171.094C415.788 171.743 415.884 172.511 415.884 173.397ZM413.889 173.397C413.889 172.679 413.837 172.086 413.735 171.619C413.637 171.153 413.506 170.784 413.343 170.513C413.179 170.243 412.99 170.054 412.776 169.946C412.566 169.839 412.349 169.785 412.125 169.785C411.901 169.785 411.684 169.839 411.474 169.946C411.268 170.054 411.084 170.243 410.921 170.513C410.762 170.784 410.634 171.153 410.536 171.619C410.438 172.086 410.389 172.679 410.389 173.397C410.389 174.121 410.438 174.716 410.536 175.182C410.634 175.649 410.762 176.018 410.921 176.288C411.084 176.559 411.268 176.748 411.474 176.855C411.684 176.963 411.901 177.016 412.125 177.016C412.349 177.016 412.566 176.963 412.776 176.855C412.99 176.748 413.179 176.559 413.343 176.288C413.506 176.018 413.637 175.649 413.735 175.182C413.837 174.716 413.889 174.121 413.889 173.397ZM424.005 173.397C424.005 174.284 423.909 175.054 423.718 175.707C423.526 176.361 423.263 176.902 422.927 177.331C422.591 177.756 422.192 178.073 421.73 178.283C421.272 178.489 420.778 178.591 420.246 178.591C419.714 178.591 419.219 178.489 418.762 178.283C418.304 178.073 417.91 177.756 417.579 177.331C417.247 176.902 416.986 176.361 416.795 175.707C416.608 175.054 416.515 174.284 416.515 173.397C416.515 172.511 416.608 171.743 416.795 171.094C416.986 170.441 417.247 169.902 417.579 169.477C417.91 169.048 418.304 168.731 418.762 168.525C419.219 168.315 419.714 168.21 420.246 168.21C420.778 168.21 421.272 168.315 421.73 168.525C422.192 168.731 422.591 169.048 422.927 169.477C423.263 169.902 423.526 170.441 423.718 171.094C423.909 171.743 424.005 172.511 424.005 173.397ZM422.01 173.397C422.01 172.679 421.958 172.086 421.856 171.619C421.758 171.153 421.627 170.784 421.464 170.513C421.3 170.243 421.111 170.054 420.897 169.946C420.687 169.839 420.47 169.785 420.246 169.785C420.022 169.785 419.805 169.839 419.595 169.946C419.389 170.054 419.205 170.243 419.042 170.513C418.883 170.784 418.755 171.153 418.657 171.619C418.559 172.086 418.51 172.679 418.51 173.397C418.51 174.121 418.559 174.716 418.657 175.182C418.755 175.649 418.883 176.018 419.042 176.288C419.205 176.559 419.389 176.748 419.595 176.855C419.805 176.963 420.022 177.016 420.246 177.016C420.47 177.016 420.687 176.963 420.897 176.855C421.111 176.748 421.3 176.559 421.464 176.288C421.627 176.018 421.758 175.649 421.856 175.182C421.958 174.716 422.01 174.121 422.01 173.397ZM432.928 170.779C432.928 171.157 432.863 171.5 432.732 171.808C432.601 172.116 432.424 172.382 432.2 172.606C431.981 172.826 431.726 172.996 431.437 173.117C431.148 173.234 430.847 173.292 430.534 173.292C430.189 173.292 429.871 173.234 429.582 173.117C429.293 172.996 429.041 172.826 428.826 172.606C428.616 172.382 428.45 172.116 428.329 171.808C428.212 171.5 428.154 171.157 428.154 170.779C428.154 170.387 428.212 170.035 428.329 169.722C428.45 169.405 428.616 169.137 428.826 168.917C429.041 168.693 429.293 168.521 429.582 168.399C429.871 168.278 430.189 168.217 430.534 168.217C430.879 168.217 431.199 168.278 431.493 168.399C431.787 168.521 432.039 168.693 432.249 168.917C432.464 169.137 432.629 169.405 432.746 169.722C432.867 170.035 432.928 170.387 432.928 170.779ZM431.444 170.779C431.444 170.527 431.421 170.317 431.374 170.149C431.327 169.977 431.262 169.839 431.178 169.736C431.099 169.634 431.003 169.561 430.891 169.519C430.779 169.473 430.66 169.449 430.534 169.449C430.408 169.449 430.289 169.473 430.177 169.519C430.07 169.561 429.976 169.634 429.897 169.736C429.822 169.839 429.762 169.977 429.715 170.149C429.673 170.317 429.652 170.527 429.652 170.779C429.652 171.027 429.673 171.232 429.715 171.395C429.762 171.559 429.822 171.692 429.897 171.794C429.976 171.892 430.07 171.962 430.177 172.004C430.289 172.046 430.408 172.067 430.534 172.067C430.66 172.067 430.779 172.046 430.891 172.004C431.003 171.962 431.099 171.892 431.178 171.794C431.262 171.692 431.327 171.559 431.374 171.395C431.421 171.232 431.444 171.027 431.444 170.779ZM436.218 168.616C436.283 168.542 436.36 168.474 436.449 168.413C436.542 168.353 436.671 168.322 436.834 168.322H438.241L430.646 178.199C430.581 178.279 430.501 178.346 430.408 178.402C430.315 178.454 430.2 178.479 430.065 178.479H428.63L436.218 168.616ZM438.71 176.092C438.71 176.47 438.645 176.813 438.514 177.121C438.383 177.429 438.206 177.695 437.982 177.919C437.763 178.139 437.508 178.309 437.219 178.43C436.93 178.547 436.629 178.605 436.316 178.605C435.971 178.605 435.653 178.547 435.364 178.43C435.075 178.309 434.823 178.139 434.608 177.919C434.398 177.695 434.232 177.429 434.111 177.121C433.994 176.813 433.936 176.47 433.936 176.092C433.936 175.7 433.994 175.348 434.111 175.035C434.232 174.718 434.398 174.45 434.608 174.23C434.823 174.006 435.075 173.836 435.364 173.719C435.653 173.598 435.971 173.537 436.316 173.537C436.661 173.537 436.981 173.598 437.275 173.719C437.569 173.836 437.821 174.006 438.031 174.23C438.246 174.45 438.411 174.718 438.528 175.035C438.649 175.348 438.71 175.7 438.71 176.092ZM437.226 176.092C437.226 175.84 437.203 175.63 437.156 175.462C437.109 175.29 437.044 175.152 436.96 175.049C436.881 174.947 436.785 174.874 436.673 174.832C436.561 174.786 436.442 174.762 436.316 174.762C436.19 174.762 436.071 174.786 435.959 174.832C435.852 174.874 435.758 174.947 435.679 175.049C435.604 175.152 435.544 175.29 435.497 175.462C435.455 175.63 435.434 175.84 435.434 176.092C435.434 176.34 435.455 176.545 435.497 176.708C435.544 176.872 435.604 177.005 435.679 177.107C435.758 177.205 435.852 177.275 435.959 177.317C436.071 177.359 436.19 177.38 436.316 177.38C436.442 177.38 436.561 177.359 436.673 177.317C436.785 177.275 436.881 177.205 436.96 177.107C437.044 177.005 437.109 176.872 437.156 176.708C437.203 176.545 437.226 176.34 437.226 176.092Z",
    fill: "white"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M359.09 292.143C343.35 292.143 330.59 279.506 330.59 263.919C330.59 248.331 343.35 235.695 359.09 235.695C374.83 235.695 387.59 248.331 387.59 263.919C387.59 279.506 374.83 292.143 359.09 292.143ZM359.09 277.288C366.546 277.288 372.59 271.302 372.59 263.919C372.59 256.535 366.546 250.549 359.09 250.549C351.634 250.549 345.59 256.535 345.59 263.919C345.59 271.302 351.634 277.288 359.09 277.288Z",
    fill: "#E1E8FF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M365.09 287.191C349.35 287.191 336.59 274.555 336.59 258.967C336.59 243.379 349.35 230.743 365.09 230.743C380.83 230.743 393.59 243.379 393.59 258.967C393.59 274.555 380.83 287.191 365.09 287.191ZM365.09 272.336C372.546 272.336 378.59 266.351 378.59 258.967C378.59 251.584 372.546 245.598 365.09 245.598C357.634 245.598 351.59 251.584 351.59 258.967C351.59 266.351 357.634 272.336 365.09 272.336Z",
    fill: "url(#paint24_linear_408_60)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M365.09 238.171C353.492 238.171 344.09 247.482 344.09 258.967C344.09 270.453 353.492 279.764 365.09 279.764V279.764C376.688 279.764 386.09 270.453 386.09 258.967",
    stroke: "white",
    strokeWidth: 15
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M430.09 292.143C414.35 292.143 401.59 279.506 401.59 263.919C401.59 248.331 414.35 235.695 430.09 235.695C445.83 235.695 458.59 248.331 458.59 263.919C458.59 279.506 445.83 292.143 430.09 292.143ZM430.09 277.288C437.546 277.288 443.59 271.302 443.59 263.919C443.59 256.535 437.546 250.549 430.09 250.549C422.634 250.549 416.59 256.535 416.59 263.919C416.59 271.302 422.634 277.288 430.09 277.288Z",
    fill: "#E1E8FF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M436.09 287.191C420.35 287.191 407.59 274.555 407.59 258.967C407.59 243.379 420.35 230.743 436.09 230.743C451.83 230.743 464.59 243.379 464.59 258.967C464.59 274.555 451.83 287.191 436.09 287.191ZM436.09 272.336C443.546 272.336 449.59 266.351 449.59 258.967C449.59 251.584 443.546 245.598 436.09 245.598C428.634 245.598 422.59 251.584 422.59 258.967C422.59 266.351 428.634 272.336 436.09 272.336Z",
    fill: "url(#paint25_linear_408_60)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M436.09 238.171C424.492 238.171 415.09 247.482 415.09 258.967C415.09 270.453 424.492 279.764 436.09 279.764V279.764C447.688 279.764 457.09 270.453 457.09 258.967",
    stroke: "white",
    strokeWidth: 15
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M437.09 236.19C425.492 236.19 416.09 245.501 416.09 256.987C416.09 268.472 425.492 277.783 437.09 277.783V277.783C448.688 277.783 458.09 268.472 458.09 256.987",
    stroke: "white",
    strokeWidth: 15
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_408_60",
    x1: 451.589,
    y1: 0,
    x2: 451.589,
    y2: 619.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBE7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_408_60",
    x1: 450.9,
    y1: 0,
    x2: 450.9,
    y2: 617.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#486757"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_408_60",
    x1: 731.59,
    y1: 375.329,
    x2: 731.59,
    y2: 642.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7FFDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_408_60",
    x1: 154.84,
    y1: 36.1465,
    x2: 154.84,
    y2: 689.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#486757",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_408_60",
    x1: 562.367,
    y1: 184.213,
    x2: 568.846,
    y2: 214.704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#122738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5566"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_408_60",
    x1: 545.34,
    y1: 272.584,
    x2: 555.903,
    y2: 272.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#122738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5566"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_408_60",
    x1: 581.903,
    y1: 263.733,
    x2: 592.465,
    y2: 263.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#122738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5566"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_408_60",
    x1: 600.59,
    y1: 274.596,
    x2: 610.34,
    y2: 274.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#122738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#122738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#122738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_408_60",
    x1: 564.028,
    y1: 268.963,
    x2: 573.778,
    y2: 268.963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#122738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5566"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_408_60",
    x1: 319,
    y1: 382.261,
    x2: 319,
    y2: 649.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7FFDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_408_60",
    x1: 480.59,
    y1: 230.743,
    x2: 480.59,
    y2: 287.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#122738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5566"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_408_60",
    x1: 709.016,
    y1: 398.182,
    x2: 682.698,
    y2: 602.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#486757",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_408_60",
    x1: 760.587,
    y1: 402.809,
    x2: 735.709,
    y2: 596.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#486757",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_408_60",
    x1: 739.664,
    y1: 285.26,
    x2: 724.251,
    y2: 405.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2FDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8EEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_408_60",
    x1: 763.295,
    y1: 335.754,
    x2: 743.137,
    y2: 420.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68C9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68C9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_408_60",
    x1: 751.043,
    y1: 427.997,
    x2: 747.209,
    y2: 457.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB37F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA263"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_408_60",
    x1: 780.465,
    y1: 304.007,
    x2: 763.67,
    y2: 434.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_408_60",
    x1: 743.997,
    y1: 281.798,
    x2: 741.078,
    y2: 304.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBE7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_408_60",
    x1: 724.225,
    y1: 284.996,
    x2: 722.206,
    y2: 300.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBE7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_408_60",
    x1: 635.664,
    y1: 363.186,
    x2: 632.665,
    y2: 386.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5935B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_408_60",
    x1: 679.47,
    y1: 277.971,
    x2: 666.49,
    y2: 378.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_408_60",
    x1: 698.385,
    y1: 321.116,
    x2: 682.849,
    y2: 351.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68C9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68C9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_408_60",
    x1: 265.996,
    y1: 416.992,
    x2: 273.179,
    y2: 600.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D8F7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44B09D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_408_60",
    x1: 335.59,
    y1: 155.479,
    x2: 335.59,
    y2: 223.811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#122738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5566"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_408_60",
    x1: 336.59,
    y1: 230.743,
    x2: 336.59,
    y2: 287.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#122738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5566"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_408_60",
    x1: 407.59,
    y1: 230.743,
    x2: 407.59,
    y2: 287.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#122738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5566"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_408_60"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 105,
    height: 68.3317,
    fill: "white",
    transform: "translate(335.59 155.479)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroimagev4);
export default __webpack_public_path__ + "static/media/heroimagev4.70e615d6af49c160e2db8314d922c56a.svg";
export { ForwardRef as ReactComponent };